import * as Eq from "fp-ts/es6/Eq"

export type ActivitySettingsMuscles = Record<string, unknown>
export const activitySettingsMuscles: Eq.Eq<ActivitySettingsMuscles> =
  Eq.struct({})
export const empty: ActivitySettingsMuscles = {}
